import React from 'react';
import renderHTML from 'react-render-html';
import { Desktop, Mobile } from '../../../../app-responsive';
import TextWithTooltip from '../../../../components/text-with-tooltip/text-with-tooltip';
import SummaryDetails from '../../ssm-components/summary-details/summary-details';
import SSMFieldWrapper from '../ssm-field-wrapper/ssm-field-wrapper';
import TextFieldResizable from '../../../../components/form/text-field-resizable';
import FormSelectField from '../../../../components/form/select-field';
import DeviceItem from '../../ssm-components/device-item/device-item';
import DeviceHeader from '../../ssm-components/device-header/device-header';
import {
  BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN,
  BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS,
  SERVICE_TERM_ADDITIONAL_INFO,
  BUSINESS_CONTINUITY,
  SIP_CALLING_PLAN_BUSINESS_LINE,
  SIP_CALLING_PLAN_BUSINESS_TRUNK,
  SIP_CONNECT_SERVICE_TERM_DEVICE_TYPE_ESTABLISHMENT_FEES,
  MOBILITY_ESTABLISHMENT_FEES,
  BUSINESS_CONTINUITY_ESTABLISHMENT_FEES,
  MOBILITY_CONTINUITY,
  PAYMENT_TYPE_MONTHLY,
  SERVICE_TERM_DEVICE_TYPE_INTEGRATEDACCESSDEVICES,
  PAYMENT_TYPE_ONEOFF,
  IAD_DEVICE_425,
  IAD_DEVICE_270,
  IAD_DEVICE_700,
  IAD_DEVICE_NOT_REQUIRED,
} from '../../../../app-constants';
import FormError from '../../../../components/form/error/error';
import './sip-connect-service-term.css';

const SipConnectServiceTerm = (props) => {
  const {
    authorableContent: {
      serviceTermHeading,
      serviceTermDescription,
      enterpriseTrunkingServiceTermDescription,
      contractTermText,
      perMonthLabel,
      estimatedOnceoffCharges,
      estimatedMonthlyCharges,
      formFields: {
        contractTerm,
        businessContinuity,
      },
    },
    sipConnectCallingPlanauthorableContent,
    siteId,
    sitesSipContractMonthsData,
    sipServiceTermContractTermSelectionChanged,
    products,
    deviceQuantityOnChange,
    deviceQuantityOnBlur,
    deviceQuantityData,
    numberOfTrunks,
    additionalInfoOnChange,
    additionalInfoOnBlur,
    formFieldsState,
    customerBillingAccountNumber,
    customerAccountNumbers,
    onAccountNumberSelectionOnBlur,
    inDial,
    ISDN2,
    sipConnectDevice,
    serviceTermAuthorableContent: {
      quantityLabel,
      unitPriceLabel,
      priceLabel,
      dateAndInfo,
      billing,
      gstText,
      itemsLabel,
    },
    formSubmitted,
    isEnterpriseTrunkForSiteSelected,
  } = props;

  const {
    formFields,
    additionalInfoHeading,
  } = dateAndInfo;

  const fieldWrapperConfiguration = {
    authorableContent: formFields,
    state: formFieldsState,
    onBlurFunction: additionalInfoOnBlur,
    onChangeFunction: additionalInfoOnChange,
    hasErrors: { SERVICE_TERM_ADDITIONAL_INFO: false },
  };

  const {
    title: billingTitle,
    accountNumberPreText: billingAccountNumberPreText,
    accountNumberPostText: billingAccountNumberPostText,
    accountNumberLabel: billingAccountNumberLabel,

  } = billing;

  const {
    title: estimatedOnceOffTitle,
    tooltip: estimatedOnceOffToolTip,
  } = estimatedOnceoffCharges;

  const {
    title: estimatedMonthlyTitle,
    tooltip: estimatedMonthlyToolTip,
  } = estimatedMonthlyCharges;

  const callingPlanSelected = (inDial === false) ? SIP_CALLING_PLAN_BUSINESS_LINE : SIP_CALLING_PLAN_BUSINESS_TRUNK;

  const defaultBillingAccountNumber = customerAccountNumbers[0];
  const customerBIllingAccountInformationText = `${billingAccountNumberPreText} ${defaultBillingAccountNumber}. ${billingAccountNumberPostText}`;

  const billingAccountNumberOptions = customerAccountNumbers.map(accountNumber => (
    {
      id: accountNumber,
      value: accountNumber,
    }
  ));

  const getItemTitle = (item) => {
    const planName = sipConnectCallingPlanauthorableContent[callingPlanSelected].planName;
    return `${item.title} ${planName}`;
  };

  const getCallingPlanUnitPriceText = () => {
    const priceText = sipConnectCallingPlanauthorableContent[callingPlanSelected].priceText;
    return priceText;
  };

  const getUnitRentalPrice = (item, product) => {
    switch (product.deviceType) {
      case BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN: {
        const priceText = sipConnectCallingPlanauthorableContent[callingPlanSelected].priceText;
        const priceValueText = priceText.split('/')[0].replace('$', '');
        return parseInt(priceValueText, 10);
      }
      default:
        return item.rentalPrice;
    }
  };


  const devices = product => product.items.map((item) => {
    const deviceType = product.deviceType;

    const deviceQuanityDataItem = deviceQuantityData.filter(
      quantityItem => quantityItem.id === `${deviceType}-${item.itemName}-${siteId}-quantity`)[0];

    let quantityValue = 0;

    switch (deviceType) {
      case BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN: {
        if (inDial && ISDN2 && sipConnectDevice !== IAD_DEVICE_NOT_REQUIRED) {
          quantityValue = numberOfTrunks;
        } else {
          quantityValue = numberOfTrunks;
        }
        break;
      }
      case SERVICE_TERM_DEVICE_TYPE_INTEGRATEDACCESSDEVICES: {
        if (sipConnectDevice === IAD_DEVICE_425) {
          if (item.itemName === IAD_DEVICE_425) {
            quantityValue = 1;
          }
          if (item.itemName === IAD_DEVICE_270) {
            quantityValue = 0;
          }
          if (item.itemName === IAD_DEVICE_700) {
            quantityValue = 0;
          }
        } else if (sipConnectDevice === IAD_DEVICE_270) {
          if (item.itemName === IAD_DEVICE_425) {
            quantityValue = 0;
          }
          if (item.itemName === IAD_DEVICE_270) {
            quantityValue = 1;
          }
          if (item.itemName === IAD_DEVICE_700) {
            quantityValue = 0;
          }
        } else if (sipConnectDevice === IAD_DEVICE_700) {
          if (item.itemName === IAD_DEVICE_425) {
            quantityValue = 0;
          }
          if (item.itemName === IAD_DEVICE_270) {
            quantityValue = 0;
          }
          if (item.itemName === IAD_DEVICE_700) {
            quantityValue = 1;
          }
        } else {
          if (item.itemName === IAD_DEVICE_425) {
            quantityValue = 0;
          }
          if (item.itemName === IAD_DEVICE_270) {
            quantityValue = 0;
          }
          if (item.itemName === IAD_DEVICE_700) {
            quantityValue = 0;
          }
        }
        break;
      }
      case BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS: {
        if (item.itemName === BUSINESS_CONTINUITY) {
          quantityValue = deviceQuanityDataItem ? deviceQuanityDataItem.quantity : '0';
        } else {
          quantityValue = deviceQuanityDataItem ? deviceQuanityDataItem.quantity : '';
        }
        break;
      }
      case SIP_CONNECT_SERVICE_TERM_DEVICE_TYPE_ESTABLISHMENT_FEES: {
        if (item.itemName === MOBILITY_ESTABLISHMENT_FEES) {
          const mobilityFeaturePack = deviceQuantityData.find(
            quantityItem => quantityItem.id === `${BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS}-${MOBILITY_CONTINUITY}-${siteId}-quantity`);
          quantityValue = mobilityFeaturePack && mobilityFeaturePack.quantity ? parseInt(mobilityFeaturePack.quantity, 10) : 0;
        } else if (item.itemName === BUSINESS_CONTINUITY_ESTABLISHMENT_FEES) {
          const businessContinuityFeaturePack = deviceQuantityData.find(
            quantityItem => quantityItem.id === `${BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS}-${BUSINESS_CONTINUITY}-${siteId}-quantity`);
          quantityValue = businessContinuityFeaturePack ? parseInt(businessContinuityFeaturePack.quantity, 10) : 0;
        }
        break;
      }

      default:
        quantityValue = deviceQuanityDataItem ? deviceQuanityDataItem.quantity : '';
    }
    const labels = { device: product.label, quantity: quantityLabel, unit: unitPriceLabel, price: priceLabel, toolTip: product.summary };

    const showDropDownInQuantity = item.itemName === BUSINESS_CONTINUITY;
    const showEnterPriseTrunkingItems = item.itemName === MOBILITY_CONTINUITY || item.itemName === MOBILITY_ESTABLISHMENT_FEES;

    const emptyDeviceQuantityData = 0;
    return (
      <DeviceItem
        key={`${deviceType}-${item.itemName}-${siteId}`}
        deviceKey={`${deviceType}-${item.itemName}-${siteId}`}
        deviceName={product.deviceType === BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN ? getItemTitle(item) : item.title}
        readOnlyQuantity={product.readOnlyQuantities}
        linkText={item.linkText}
        linkURL={item.linkURL}
        deviceToolTipText={item.tooltip}
        deviceToolTipImagePath={item.tooltipImg}
        unitPricePurchaseValue={item.purchasePrice}
        unitPriceRentalValue={getUnitRentalPrice(item, product)}
        unitPriceSuffixText={(product.deviceType === SIP_CONNECT_SERVICE_TERM_DEVICE_TYPE_ESTABLISHMENT_FEES ||
          product.deviceType === SERVICE_TERM_DEVICE_TYPE_INTEGRATEDACCESSDEVICES)
          ? '' : perMonthLabel}
        paymentType={product.paymentType}
        serviceTermSelectedOption={product.paymentType === PAYMENT_TYPE_MONTHLY ? 'rental' : 'onceOff'}
        quantityValue={quantityValue}
        quantityInputOnChange={deviceQuantityOnChange}
        quantityInputOnBlur={deviceQuantityOnBlur}
        quantityMin={emptyDeviceQuantityData}
        labels={labels}
        emptyDeviceQuantityData={emptyDeviceQuantityData}
        bsipUnitPriceSuffixText={product.deviceType === BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN ?
          getCallingPlanUnitPriceText() : item.priceAdditionalText}
        bsipItem
        unitPriceTextOverride={product.deviceType === BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN}
        showDropDownInQuantity={showDropDownInQuantity}
        dropDownContent={businessContinuity}
        isEnterpriseTrunkForSiteSelected={showEnterPriseTrunkingItems === false && isEnterpriseTrunkForSiteSelected}
      />
    );
  });


  const monthlyTotalCost = (services) => {
    let totalCost = 0;
    services.forEach((service) => {
      service.items.forEach((item) => {
        const deviceType = service.deviceType;
        const deviceQuanityDataItem = deviceQuantityData.filter(
          quantityItem => quantityItem.id === `${deviceType}-${item.itemName}-${siteId}-quantity`)[0];
        let quantityValue = 0;
        switch (deviceType) {
          case BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN: {
            if (isEnterpriseTrunkForSiteSelected === false) {
              if (inDial && ISDN2 && sipConnectDevice !== IAD_DEVICE_NOT_REQUIRED) {
                quantityValue = numberOfTrunks;
              } else {
                quantityValue = numberOfTrunks;
              }
            }
            break;
          }
          case SIP_CONNECT_SERVICE_TERM_DEVICE_TYPE_ESTABLISHMENT_FEES: {
            if (item.itemName === MOBILITY_ESTABLISHMENT_FEES) {
              const mobilityFeaturePack = deviceQuantityData.find(
                quantityItem => quantityItem.id === `${BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS}-${MOBILITY_CONTINUITY}-${siteId}-quantity`);
              quantityValue = mobilityFeaturePack && mobilityFeaturePack.quantity ? parseInt(mobilityFeaturePack.quantity, 10) : 0;
            } else if (item.itemName === BUSINESS_CONTINUITY_ESTABLISHMENT_FEES && isEnterpriseTrunkForSiteSelected === false) {
              const businessContinuityFeaturePack = deviceQuantityData.find(
                quantityItem => quantityItem.id === `${BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS}-${BUSINESS_CONTINUITY}-${siteId}-quantity`);
              quantityValue = businessContinuityFeaturePack ? parseInt(businessContinuityFeaturePack.quantity, 10) : 0;
            }
            break;
          }
          case SERVICE_TERM_DEVICE_TYPE_INTEGRATEDACCESSDEVICES: {
            if (isEnterpriseTrunkForSiteSelected === false) {
              if (sipConnectDevice === IAD_DEVICE_425) {
                if (item.itemName === IAD_DEVICE_425) {
                  quantityValue = 1;
                }
                if (item.itemName === IAD_DEVICE_270) {
                  quantityValue = 0;
                }
                if (item.itemName === IAD_DEVICE_700) {
                  quantityValue = 0;
                }
              } else if (sipConnectDevice === IAD_DEVICE_270) {
                if (item.itemName === IAD_DEVICE_425) {
                  quantityValue = 0;
                }
                if (item.itemName === IAD_DEVICE_270) {
                  quantityValue = 1;
                }
                if (item.itemName === IAD_DEVICE_700) {
                  quantityValue = 0;
                }
              } else if (sipConnectDevice === IAD_DEVICE_700) {
                if (item.itemName === IAD_DEVICE_425) {
                  quantityValue = 0;
                }
                if (item.itemName === IAD_DEVICE_270) {
                  quantityValue = 0;
                }
                if (item.itemName === IAD_DEVICE_700) {
                  quantityValue = 1;
                }
              } else {
                if (item.itemName === IAD_DEVICE_425) {
                  quantityValue = 0;
                }
                if (item.itemName === IAD_DEVICE_270) {
                  quantityValue = 0;
                }
                if (item.itemName === IAD_DEVICE_700) {
                  quantityValue = 0;
                }
              }
            }
            break;
          }
          case BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS: {
            if (item.itemName === BUSINESS_CONTINUITY && isEnterpriseTrunkForSiteSelected) {
              quantityValue = 0;
            } else {
              quantityValue = deviceQuanityDataItem ? deviceQuanityDataItem.quantity : 0;
            }
            break;
          }
          default:
            quantityValue = deviceQuanityDataItem ? deviceQuanityDataItem.quantity : 0;
        }
        totalCost += (quantityValue * getUnitRentalPrice(item, service));
      });
    });
    return totalCost;
  };


  const monthlyTotal = (services => monthlyTotalCost(services.filter(service => service.paymentType !== PAYMENT_TYPE_ONEOFF)));
  const oneOffTotal = (services => monthlyTotalCost(services.filter(service => service.paymentType === PAYMENT_TYPE_ONEOFF)));

  const contractTermSelectionText = sitesSipContractMonthsData && sitesSipContractMonthsData[siteId];
  const monthlyTitle = `${estimatedMonthlyTitle} ${contractTermSelectionText} ${gstText}`;
  const showError = () => {
    if (formSubmitted === true && (sitesSipContractMonthsData[siteId] === undefined ||
      sitesSipContractMonthsData[siteId] === contractTerm.placeholder)) {
      return true;
    }
    return false;
  };

  return (
    <div className="sip-connect-service-term">
      {isEnterpriseTrunkForSiteSelected === false &&
        <React.Fragment>
          <div className="row">
            <div className="col-12 pl-sm-0">
              <h2 id="sip-connect-service-section-heading" className="sip-connect-service-section-heading">{serviceTermHeading}</h2>
            </div>
          </div>
          {isEnterpriseTrunkForSiteSelected === false &&
            <div className="row dropdown-row">
              <div className="col-md-6 col-sm-12 pl-sm-0 dropdown-contract-term">
                <span>{contractTermText}</span>
              </div>
              <div className="col-md-3">
                <FormSelectField
                  id="sip-connect-contract-term-month-selection"
                  label=""
                  disabled={false}
                  options={contractTerm.options}
                  value={sitesSipContractMonthsData &&
                    (sitesSipContractMonthsData[siteId] !== undefined) ? sitesSipContractMonthsData[siteId] : contractTerm.placeholder}
                  onBlur={sipServiceTermContractTermSelectionChanged}
                  placeholder=""
                  initialValuePresent
                />
                {showError() &&
                  <FormError errorText={contractTerm.errorText} />
                }
              </div>
            </div>
          }
          {isEnterpriseTrunkForSiteSelected &&
          <div className="row">
            <div className="col-12 pl-sm-0">
              <span className="service-term-description">{renderHTML(enterpriseTrunkingServiceTermDescription)}</span>
            </div>
          </div>
          }
          {isEnterpriseTrunkForSiteSelected === false &&
          <div className="row">
            <div className="col-12 pl-sm-0">
              <span className="service-term-description">{renderHTML(serviceTermDescription)}</span>
            </div>
          </div>
          }
          <DeviceHeader
            deviceNameHeadingText={itemsLabel}
            quantityHeadingText={quantityLabel}
            unitPriceHeadingText={unitPriceLabel}
            priceNameHeadingText={priceLabel}
          />
          {products.map(product =>
            (<div key={`${product.deviceType}-sip-connect-device-${siteId}`} >
              <div className={`sip-connect-devices ${product.deviceType}-sip-connect-devices`}>
                {devices(product)}
              </div>
            </div>),
          )}

          <Desktop>
            <div className="row">
              <div className="col-md-6 estimated-once-off-cost estimated-cost-description">
                <div>
                  {estimatedOnceOffTitle}
                  <TextWithTooltip
                    text={<i className="td-icon icon-help" />}
                    textClassName="help-icon-container"
                    id="estimated-once-off-cost-tooltip"
                    toolTipText={estimatedOnceOffToolTip}
                  />
                </div>
              </div>

              <div className="col-md-6 estimated-monthly-cost estimated-cost-description">
                <div>
                  {monthlyTitle}
                  <TextWithTooltip
                    text={<i className="td-icon icon-help" />}
                    textClassName="help-icon-container"
                    id="estimated-monthly-cost-tooltip"
                    toolTipText={estimatedMonthlyToolTip}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 estimated-once-off-cost estimated-cost-price">
                <div>
                  <div className="total-price-estimate"><sup>$</sup>
                    {Number.isInteger(oneOffTotal(products)) ? oneOffTotal(products) :
                      oneOffTotal(products).toFixed(2)}
                  </div>
                </div>
              </div>
              <div className="col-md-6 estimated-monthly-cost estimated-cost-price">
                <div className="total-price-estimate"><sup>$</sup>
                  {Number.isInteger(monthlyTotal(products)) ? monthlyTotal(products) :
                    monthlyTotal(products).toFixed(2)}<sub>{perMonthLabel}</sub></div>
              </div>
            </div>
          </Desktop>
          <Mobile>
            <div className="row estimated-once-off-cost mobile-seperation">
              <div className="col-12 estimated-cost-description">
                {estimatedOnceOffTitle}
                <TextWithTooltip
                  text={<i className="td-icon icon-help" />}
                  textClassName="help-icon-container"
                  id="estimated-once-off-cost-tooltip"
                  toolTipText={estimatedOnceOffToolTip}
                />
              </div>
              <div className="col-12 estimated-cost-price">
                <div className="mobile-totals total-price-estimate"><sup>$</sup>
                  {Number.isInteger(oneOffTotal(products)) ? oneOffTotal(products) :
                    oneOffTotal(products).toFixed(2)}
                </div>
              </div>
            </div>

            <div className="row estimated-monthly-cost">
              <div className="col-12  estimated-cost-description">
                <div>
                  {monthlyTitle}
                  <TextWithTooltip
                    text={<i className="td-icon icon-help" />}
                    textClassName="help-icon-container"
                    id="estimated-monthly-cost-tooltip"
                    toolTipText={estimatedMonthlyToolTip}
                  />
                </div>
              </div>
              <div className="col-12 estimated-cost-price">
                <div className="mobile-totals total-price-estimate"><sup>$</sup>
                  {Number.isInteger(monthlyTotal(products)) ? monthlyTotal(products) :
                    monthlyTotal(products).toFixed(2)}<sub>{perMonthLabel}</sub></div>
              </div>
            </div>
          </Mobile>
        </React.Fragment>
      }

      <div className="billing-section">
        <SummaryDetails
          summaryTitle={billingTitle}
          summaryText={customerBIllingAccountInformationText}
        />
      </div>
      <div className="row">
        <div className="input-label col-md-2 pl-sm-0">
          {billingAccountNumberLabel}
        </div>
        <div className="col-md-3">
          <FormSelectField
            id="service-term-billing-accounts-list"
            label=""
            disabled={false}
            options={billingAccountNumberOptions}
            value={customerBillingAccountNumber}
            onBlur={onAccountNumberSelectionOnBlur}
            placeholder=""
            initialValuePresent
          />
        </div>
      </div>
      <div className="row additional-info-section">
        <div className="col pl-sm-0">
          <h2 id="summary-heading" className="summary-heading">{additionalInfoHeading}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={TextFieldResizable}
            id={SERVICE_TERM_ADDITIONAL_INFO}
            customClass="block-spacer"
          />
        </div>
      </div>

    </div>
  );
};

export default SipConnectServiceTerm;
